import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function PreviewCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const slides = [{
    id: 1,
    image: 'https://cdn.magicpatterns.com/uploads/cpWYbCMCUYDvUb9Sqj2Tok/Captura_de_pantalla_2026-03-10_160044.png',
    alt: 'Índice General — Tomo 1 e Introducción a la Planificación'
  }, {
    id: 2,
    image: 'https://cdn.magicpatterns.com/uploads/rwLCxF7Pk3889qNt2ebWGK/Captura_de_pantalla_2026-03-10_160215.png',
    alt: 'Por qué es tan importante planificar tu tiempo y Los 3 pilares'
  }, {
    id: 3,
    image: 'https://cdn.magicpatterns.com/uploads/99MaEuUw3fD4cTAT312y8t/Captura_de_pantalla_2026-03-10_160234.png',
    alt: 'Calendario cuatrimestral completo y Recurso Imprimible'
  }, {
    id: 4,
    image: 'https://cdn.magicpatterns.com/uploads/mArHaZMvw1BdwqESBAoqKm/Captura_de_pantalla_2026-03-10_162353.png',
    alt: 'Índice General Tomo 2 y Estudiar en 2026: El Nuevo Método Híbrido'
  }, {
    id: 5,
    image: 'https://cdn.magicpatterns.com/uploads/3QfcAsvhV7SGorYWyEVRiR/Captura_de_pantalla_2026-03-10_162409.png',
    alt: 'Qué es el enfoque híbrido y Vieja Escuela vs IA vs Híbrido'
  }];
  const nextSlide = () => {
    setDirection(1);
    setCurrentIndex(prevIndex => prevIndex === slides.length - 1 ? 0 : prevIndex + 1);
  };
  const prevSlide = () => {
    setDirection(-1);
    setCurrentIndex(prevIndex => prevIndex === 0 ? slides.length - 1 : prevIndex - 1);
  };
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    })
  };
  return <section className="w-full py-24 bg-[#F9F9F9] px-4 overflow-hidden" data-id="element-109">
      <div className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-110">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-6 text-center max-w-4xl leading-tight" data-id="element-111">
          Miralo por dentro: así es el MegaPack
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-600 max-w-3xl mb-16 text-center" data-id="element-112">
          Deslizá para ver algunas páginas reales del primer tomo.
        </motion.p>

        <div className="relative w-full max-w-4xl h-[300px] sm:h-[400px] md:h-[520px] lg:h-[580px] flex items-center justify-center mb-12" data-id="element-113">
          {/* Navigation Buttons */}
          <button onClick={prevSlide} className="absolute -left-2 md:-left-6 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-turquoise" aria-label="Previous slide" data-id="element-114">
            <ChevronLeftIcon className="w-6 h-6 text-[#1A1A1A]" data-id="element-115" />
          </button>

          <button onClick={nextSlide} className="absolute -right-2 md:-right-6 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-turquoise" aria-label="Next slide" data-id="element-116">
            <ChevronRightIcon className="w-6 h-6 text-[#1A1A1A]" data-id="element-117" />
          </button>

          {/* Carousel Track */}
          <div className="relative w-full h-full overflow-hidden rounded-2xl shadow-2xl bg-white flex items-center justify-center" data-id="element-118">
            <AnimatePresence initial={false} custom={direction} data-id="element-119">
              <motion.div key={currentIndex} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              x: {
                type: 'spring',
                stiffness: 300,
                damping: 30
              },
              opacity: {
                duration: 0.2
              }
            }} className="absolute w-full h-full" data-id="element-120">
                <img src={slides[currentIndex].image} alt={slides[currentIndex].alt} className="w-full h-full object-contain" data-id="element-121" />
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        {/* Indicators */}
        <div className="flex gap-3 mb-12" data-id="element-122">
          {slides.map((_, index) => <button key={index} onClick={() => {
          setDirection(index > currentIndex ? 1 : -1);
          setCurrentIndex(index);
        }} className={`w-3 h-3 rounded-full transition-colors duration-300 ${index === currentIndex ? 'bg-turquoise' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-123" />)}
        </div>

        <p className="text-gray-600 text-center font-medium" data-id="element-124">
          Esto es solo una muestra. El MegaPack completo tiene decenas de
          recursos organizados para vos.
        </p>
      </div>
    </section>;
}